<template>
    <div class="w-100">
        <ElementsUpperProductListBanner v-if="upperProductListBanner" :banner="upperProductListBanner" :breadcrumbs-items="breadcrumbs" />

        <div class="mx-auto page page-category mt-3">
            <div v-if="type === 'category'" id="js-category-stats" :data-id="categoryId"></div>

            <div class="container">
                <NavigationsBreadcrumb v-if="breadcrumbs?.length && !upperProductListBanner" :items="breadcrumbs" class="mt-0" />

                <ObjectsPerex
                    :perex-text="content"
                    :seo-perex-text="perex"
                    :title="perexTitle"
                    :banners="banners"
                    :count="$numberFormat(totalCount)"
                    :rich-content-widgets="richContentWidgets"
                    :show-more-scroll-to-element="bottomRichContentWidgets.length > 0 || bottomContent ? 'bottom-content' : ''"
                />

                <ElementsBannersTopCategory
                    v-if="isSaleAndDiscountCategory"
                    :banners="saleAndDiscountCategoryBanners?.length ? saleAndDiscountCategoryBanners : banners"
                    matomo-banner-category="Actions and sales category banner"
                />

                <ElementsPilulkaTabs :active-tab-id="'tab-all'" class="hidden-navigation">
                    <ElementsPilulkaTab tab-id="tab-all" default-active :title="$t('products')" active>
                        <DelayHydration v-if="!hasNavigationRichContentWidget">
                            <ObjectsListSubCategories
                                v-if="submenu.length"
                                id="subCategoriesATest"
                                :is-desktop="$device.isDesktop"
                                :sub-categories="submenu"
                                class="mb-4 mt-3"
                                :banners="banners"
                                :is-sale-and-discount-category="isSaleAndDiscountCategory"
                            />
                        </DelayHydration>

                        <template v-if="filterCategories?.length">
                            <h2>{{ $t('category.title') }}</h2>

                            <ObjectsListSubCategories
                                :is-desktop="$device.isDesktop"
                                :sub-categories="filterCategories"
                                class="mb-4 mt-3"
                            />
                        </template>

                        <div id="product-list" ref="productList" class="product-listScroll"></div>

                        <div v-for="(customAddonSaleCarousel, index) in customAddonSaleCarousels" :key="index">
                            <h2 :class="{ 'mt-5': index === 0 }">
                                {{ customAddonSaleCarousel.title }}
                            </h2>

                            <ElementsCarouselBox :products="customAddonSaleCarousel.products" />
                        </div>

                        <div v-if="!isCatalogDisabled" class="page row mt-3">
                            <div
                                v-if="!(totalCount === 0 && (type === 'search' || selectedFilters.length === 0))"
                                class="page__sidebar col-md-4 col-lg-3 p-0"
                                :class="{ 'page__sidebar--overlay': currentTab !== TAB_PRODUCTS }"
                            >
                                <ObjectsSidebar
                                    v-if="true"
                                    ref="sidebar"
                                    :sidebar-filters="filters"
                                    :base-path="baseUrl"
                                    :count="totalCount"
                                    :sorts="sorts"
                                    :selected-filters="selectedFilters"
                                    :sidebar-categories="submenuCategories"
                                />
                            </div>
                            <div class="page__content" :class="{ 'col-md-8 col-lg-9': totalCount !== 0, 'p-0 col-12': totalCount === 0 }">
                                <div id="service-lists" ref="productList" class="services-list">
                                    <div v-if="totalCount === 0" class="not-found">
                                        <div class="alert alert-danger px-5" role="alert" show>{{ $t('notFound.category') }}</div>

                                        <p v-if="selectedFilters.length > 0" class="text-center">
                                            <nuxt-link
                                                :to="`${baseUrl}#product-list`"
                                                class="btn btn-outline-primary btn-xs px-3 mt-2 mb-3"
                                            >
                                                {{ $t('sideBar.clearAll') }}
                                            </nuxt-link>
                                        </p>

                                        <NotFoundProductList v-if="type === 'search'" :products="mostSoldProducts" />

                                        <NotFoundBannerList v-if="type === 'search'" :banners="banners" :limit="3" />

                                        <Category404 v-if="type === 'search'" />

                                        <ObjectsNotFound />
                                    </div>
                                    <div v-else class="lists services-list__body">
                                        <div class="services-list__top">
                                            <div class="lists-back">
                                                <a
                                                    v-if="currentTab !== TAB_PRODUCTS"
                                                    :href="`${baseUrl}#product-list`"
                                                    class="btn btn-default px-4 br-10"
                                                    @click.prevent="backToProducts"
                                                >
                                                    <i class="ico-arrow left"></i> {{ $t('discussions.backToListProducts') }}
                                                </a>
                                            </div>
                                            <div v-if="currentTab === TAB_PRODUCTS" class="lists-filter">
                                                <div class="onlystock me-3 d-none d-md-block">
                                                    <nuxt-link
                                                        v-if="inStockFilter && inStockFilter.count > 0"
                                                        :to="`${inStockFilter.url}#product-list`"
                                                        class="checkbox"
                                                        :class="{ 'is-active': inStockFilter.isActive }"
                                                    >
                                                        {{ inStockFilter.title }}&nbsp;<span class="text-muted"
                                                            >({{ $numberFormat(inStockFilter.count) }})</span
                                                        >
                                                    </nuxt-link>
                                                </div>
                                                <div class="sort d-none d-md-block text-right">
                                                    <DelayHydration>
                                                        <ElementsDropdown :label="currentSortName" :items="sorts" />
                                                    </DelayHydration>
                                                </div>

                                                <a
                                                    class="btn btn-filter-and-sort btn-primary d-md-none"
                                                    href="#"
                                                    @click.prevent="showSidebar('')"
                                                >
                                                    <i class="ico ico-filter-and-sort me-3"></i> {{ $t('productList.filterAndSort') }}
                                                    <span v-if="selectedFilters.length !== 0" class="count">{{
                                                        selectedFilters.length
                                                    }}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <div v-if="selectedFilters.length > 0" class="sidebar-filter">
                                            <div v-if="currentTab === TAB_PRODUCTS" class="filters-active" data-cy="filters-active">
                                                <div class="filters-active__list">
                                                    <nuxt-link
                                                        v-for="(selectedFilter, key) in selectedFilters"
                                                        :key="key"
                                                        :to="selectedFilter.url"
                                                        class="item me-2"
                                                    >
                                                        <span v-if="selectedFilter.type">{{ selectedFilter.type }}:</span>
                                                        {{ selectedFilter.value }}
                                                        <i class="icon close"></i>
                                                    </nuxt-link>
                                                </div>
                                                <nuxt-link class="remove" :to="`${baseUrl}#product-list`">
                                                    {{ $t('productList.clearFilter') }}
                                                </nuxt-link>
                                            </div>
                                        </div>

                                        <div class="tab-content">
                                            <div v-show="currentTab === TAB_PRODUCTS">
                                                <LayoutCategoryProductListItems
                                                    :items="products"
                                                    :top-products="[]"
                                                    :lazy-image="true"
                                                    :list-title="title"
                                                    :list-type="type"
                                                    :show-products-description="showProductsDescription"
                                                >
                                                </LayoutCategoryProductListItems>
                                                <DelayHydration>
                                                    <SkeletonProductListSkeleton v-show="showNextPageLoading" />
                                                </DelayHydration>
                                            </div>
                                            <div v-show="currentTab === TAB_DISCUSSIONS">
                                                <LazyLoadComponent>
                                                    <ObjectsDiscussionFeed :category-id="categoryId" :product-id="null" />
                                                </LazyLoadComponent>
                                            </div>
                                            <div v-show="currentTab === TAB_REVIEWS">
                                                <DelayHydration>
                                                    <ObjectsReviewsReviewFeed
                                                        v-if="type !== 'search' && commentAggregate"
                                                        :feed-id="id"
                                                        :feed-type="type"
                                                        :feed-name="title"
                                                        :feed-description="metaDescription"
                                                        :reviews="commentAggregate.reviews"
                                                        :total-review="commentAggregate.rating"
                                                        :recommend-percentage="commentAggregate.recommendPercentage"
                                                        :data-loaded="showCommentAggregate"
                                                        @reviews-count="updateReviewsCount"
                                                    />
                                                </DelayHydration>
                                            </div>
                                        </div>
                                    </div>

                                    <ElementsSideBanners
                                        v-if="leftSideBanner?.desktopImage || rightSideBanner?.desktopImage"
                                        :left-side-banner="leftSideBanner"
                                        :right-side-banner="rightSideBanner"
                                    />

                                    <div
                                        v-if="currentTab === TAB_PRODUCTS && paginator && paginator.pages.length > 0"
                                        class="services-list__bottom mb-2"
                                    >
                                        <div class="wrap-backtop d-none d-xl-block mb-3">
                                            <div class="backtop" data-cy="backtop" @click="backToTop">{{ $t('top') }}</div>
                                        </div>
                                        <button
                                            v-if="paginator.nextUrl"
                                            ref="showNextPageButton"
                                            class="btn btn-link pagination__load-more mb-4"
                                            data-cy="more-products"
                                            @click="showNextPage"
                                        >
                                            {{ $t('paginator.loadMore', { number: showMoreCount }) }}
                                            <span class="ps-2">
                                                <img :src="`/nuxt-assets/icons/arrow-down-pink.svg`" alt="arrow" />
                                            </span>
                                        </button>
                                        <DelayHydration>
                                            <ElementsPagination class="mb-4 list-pagination" :pagination-data="paginator" />
                                        </DelayHydration>
                                    </div>
                                    <div v-if="totalCount !== 0" class="btn-discussion text-center">
                                        <a
                                            v-if="isDiscussionsEnabled && categoryId && currentTab !== TAB_DISCUSSIONS"
                                            :href="baseUrl + $t('discussions.url')"
                                            class="btn btn-default px-4"
                                            @click.prevent="showDiscussions"
                                        >
                                            {{ $t('discussions.btnShow') }} {{ title }}
                                        </a>
                                        <a
                                            v-if="currentTab !== TAB_REVIEWS && reviewsCount > 0"
                                            :href="baseUrl + $t('reviews.url')"
                                            class="btn btn-default px-4"
                                            @click.prevent="showReviews"
                                        >
                                            {{ $t('reviews.btnShow', { feedName: title }) }}
                                        </a>
                                    </div>

                                    <div
                                        v-if="bottomRichContentWidgets.length > 0 || bottomContent || conclusion"
                                        id="bottom-content"
                                        class="mt-4"
                                    >
                                        <TruncatedText
                                            class="service-detail__shortdesc"
                                            :is-desktop="$device.isDesktop"
                                            :text="bottomContent"
                                            :seo-perex="conclusion"
                                            :rich-content-widgets="bottomRichContentWidgets"
                                            :show-full-text="true"
                                        />
                                    </div>
                                </div>
                                <ElementsAskYourPharmacist v-if="showCounsellingBanner" class="mb-4" />
                            </div>
                        </div>
                    </ElementsPilulkaTab>

                    <ElementsPilulkaTab
                        v-for="(tabItems, tabName, index) in catalogTabs"
                        :id="`tab-reviews-` + tabName"
                        :key="index"
                        :title="$t(`search.${tabName}`)"
                        :tab-id="`tab-reviews-` + tabName"
                    >
                        <div class="row mb-3">
                            <div v-for="tabItem in tabItems" :key="tabItem.name || tabItem.title" class="col-12 col-sm-6 col-md-3 mt-3">
                                <nuxt-link :to="tabItem.url" class="mx-2 shadow text-center rounded-pill p-3 d-block">
                                    {{ tabItem.name || tabItem.title }}
                                </nuxt-link>
                            </div>
                        </div>
                    </ElementsPilulkaTab>
                </ElementsPilulkaTabs>
            </div>

            <ObjectsModalAdult v-if="isForAdultsOnly" />
            <ElementsCounsellingUpsertModal v-if="showCounsellingBanner" />

            <ChatBot v-if="chatBotShow" />

            <ElementsBackgroundBanner v-if="backgroundBanner" :banner="backgroundBanner" />

            <ElementsPopUpOutgoing v-if="popUpOutgoing" :pop-up="popUpOutgoing" :is-desktop="$device.isDesktop" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { onUpdated } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from '#imports'
import DataLayer from '~/extensions/DataLayer'
import GtmPageData from '~/models/DataLayer/GtmPageData'
import { useLayoutStore } from '~/stores/layout'
import { GtmEcommerceEventTypeEnum } from '~/models/DataLayer/GtmEcommerceEventTypeEnum'
import GtmEcommerceEvent from '~/models/DataLayer/GtmEcommerceEvent'
import useCommonStructuredData from '~/composables/useCommonStructuredData'
import LazyLoadComponent from '~/components/LazyLoadComponent.vue'
import TruncatedText from '~/components/elements/TruncatedText.vue'
import ChatBot from '~/components/elements/ChatBot.vue'
import Banner from '~/models/components/Banner'
import PilulkaHeadInfo from '~/models/Head/PilulkaHeadInfo'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import LuigisBoxFilters from '~/models/LuigisBox/LuigisBoxFilters'
import { transformProductsToLuigisBoxItems } from '~/utils/transformProductsToLuigisBoxItems'
import BreadcrumbItem from '~/models/BreadcrumbItem'
import Category404 from '~/components/layout/page/category404.vue'
import NotFoundProductList from '~/components/layout/category/NotFoundProductList.vue'
import NotFoundBannerList from '~/components/layout/category/NotFoundBannerList.vue'
import Filter from '~/models/Filters/Filter'
import { encodeSeoUrl } from '~/utils/encodeSeoUrl'
import Widget from '~/models/StaticContent/Widget'
import useProductListPageAsyncData, { useProductListAsyncData } from '~/composables/productList/useProductListPageAsyncData'
import ProductListResponse from '~/models/Api/ProductListResponse'
import Product from '~/models/Product/Product'
import SelectedFilter from '~/models/Filters/SelectedFilter'
import CategoryTile from '~/models/Category/CategoryTile'
import Paginator from '~/models/Paginator'
import BannerTile from '~/models/Category/BannerTile'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const components = {
    LazyLoadComponent,
}

const TAB_PRODUCTS = 'products'
const TAB_DISCUSSIONS = 'discussions'
const TAB_REVIEWS = 'reviews'

const catalogTabs = ref<{
    searchBrands: any[]
    searchCategories: any[]
    searchManufacturers: any[]
    searchProductLines: any[]
    searchPharmacies: any[]
    searchServiceOffices: any[]
    searchServices: any[]
    searchStaticContents: any[]
} | null>(null)
const title = ref('')
const sorts = ref([])
const paginator = ref<Paginator | null>(null)
const products = ref<Product[]>([])
const totalCount = ref(0)
const currentUrl = ref('')
const submenu = ref<CategoryTile[]>([])
const submenuCategories = ref<{ title: string; count: number; shopUrlPath: string }[]>([])
const favoriteBrands = ref(null)
const breadcrumbs = ref<BreadcrumbItem[]>([])
const filters = ref<Filter[]>([])
const selectedFilters = ref<SelectedFilter[]>([])
const baseUrl = ref('')
const redirectUrl = ref<string | null>(null)
const searchResults = ref(null)
const content = ref('')
const bottomContent = ref('')
const banners = ref<BannerTile[]>([])
const bannersCatalog = ref<Banner[]>([])
const backgroundBanner = ref(null)
const upperProductListBanner = ref(null)
const saleAndDiscountCategoryBanners = ref<Banner[]>([])
const popUpOutgoing = ref(null)
const categoryBestsellers = ref(null)
const bestSellerProducts = ref(null)
const richContentWidgets = ref<Widget[]>([])
const bottomRichContentWidgets = ref([])
const isForAdultsOnly = ref(null)
const inStockFilter = ref<{
    isActive: boolean
    count: number
    title: string
    url: string
} | null>(null)
const showProductsDescription = ref(false)
const metaDescription = ref('')
const customAddonSaleCarousels = ref<{ title: string; products: Product[] }[]>([])
const additionalItems = ref(null)
const isCatalogDisabled = ref(null)
const metaTitle = ref(null)
const perex = ref('')
const conclusion = ref('')
const newsTile = ref(null)
const giftTipTile = ref(null)
const structuredData = ref<Record<string, any>>({})
const saleAndDiscountTile = ref(null)
const filterCategories = ref<
    {
        name: string
        image: string
        imageAlt: string
        id: number
        count: number
        url: string
        countOfChildren: number
        children: []
    }[]
>([])
const referer = ref<string | null>(null)
const categoryLevel = ref(null)
const categoryId = ref<number | null>(null)
const config = useRuntimeConfig()
const route = useRoute()
const urlParams = computed(() => route.matched[0].props.default)
const params = urlParams.value as { [name: string]: string }
const isSaleAndDiscountCategory = ref(false)
const commentAggregate = ref<{
    rating: number
    recommendPercentage: number
    reviews: {
        id: number
        content: string
        rating: number
        totalComments: number
        totalReviews: number
        image: string
        productName: string
        productLink: string
    }[]
    totalReviews: number
} | null>(null)
const showCommentAggregate = ref(false)
const showComparablePrices = ref(false)
const showDiscussion = ref(false)
const showCounsellingBanner = ref(false)
const mostSoldProducts = ref([])
const sortMethod = parseInt((params.s || '1') as string)
let pageFrom = parseInt((route.query.page || '1') as string)
let pageTo = pageFrom
const reviewsCount = ref(1)
const trans = useI18n().t

const sidebar = ref(null)

let updateCounter = 0

onMounted(() => {
    pushViewItemListEvents()
})

onUpdated(() => {
    if (updateCounter > 0) {
        pushViewItemListEvents()
    }

    updateCounter++
})

const type = ref('category')
const componentName = params.componentName as string

const id = parseInt(params.id)
if (componentName === 'catalog.list') {
    categoryId.value = id
}

if (componentName === 'catalog.product_line') {
    type.value = 'productLine'
}

if (componentName === 'catalog.manufacturer') {
    type.value = 'manufacturer'
}

if (componentName === 'catalog.brand') {
    type.value = 'brand'
}

if (componentName === 'catalog.search') {
    type.value = 'search'
}

if (componentName === 'catalog.bothers_me') {
    type.value = 'bothers'
}

const setData = async (
    data: ProductListResponse,
    inputFilters: any = null,
    richContentWidgetsInput = null,
    bottomRichContentWidgetsInput = null
) => {
    if (!data) {
        throw createError({ statusCode: 404, statusMessage: 'Product list not found 2' })
    }

    saleAndDiscountTile.value = Array.isArray(data.saleAndDiscountTile) ? {} : data.saleAndDiscountTile
    catalogTabs.value = data.catalogTabs
    title.value = data.title
    sorts.value = data.sorts
    paginator.value = data.paginator
    products.value = data.products.products
    totalCount.value = data.products.total
    currentUrl.value = route.fullPath
    submenu.value = data.submenu
    submenuCategories.value = data.submenuCategories
    favoriteBrands.value = data.favoriteBrands
    breadcrumbs.value = data.breadcrumbs
    filters.value = inputFilters || data.filters
    selectedFilters.value = data.selectedFilters
    baseUrl.value = data.baseUrl
    redirectUrl.value = data.redirectUrl
    searchResults.value = data.searchResults
    content.value = encodeSeoUrl(data.content)
    bottomContent.value = data.bottomContent
    banners.value = data.productListBanners
    bannersCatalog.value = data.catalogListBanners
    backgroundBanner.value = data.backgroundBanner
    upperProductListBanner.value = data.upperProductListBanner
    saleAndDiscountCategoryBanners.value = data.saleAndDiscountCategoryBanners
    popUpOutgoing.value = data.popUpOutgoing
    categoryBestsellers.value = data.categoryBestsellers
    bestSellerProducts.value = data.bestSellerProducts
    richContentWidgets.value = richContentWidgetsInput || data.richContentWidgets
    bottomRichContentWidgets.value = bottomRichContentWidgetsInput || data.bottomRichContentWidgets
    isForAdultsOnly.value = data.isForAdultsOnly
    inStockFilter.value = data.inStockFilter
    showProductsDescription.value = data.showProductsDescription
    metaDescription.value = data.metaDescription
    customAddonSaleCarousels.value = data.customAddonSaleCarousels
    additionalItems.value = data.additionalItems
    isCatalogDisabled.value = data.isCatalogDisabled
    metaTitle.value = data.metaTitle
    perex.value = data.perex
    conclusion.value = data.conclusion
    newsTile.value = data.newsTile
    giftTipTile.value = data.giftTipTile
    structuredData.value = data.structuredData
    categoryLevel.value = data.categoryLevel
    filterCategories.value = data.filterCategories // mapFilterCategories(data)
    isSaleAndDiscountCategory.value = data.isSaleAndDiscountCategory
    commentAggregate.value = data.commentAggregate
    showCommentAggregate.value = data.showCommentAggregate
    showComparablePrices.value = data.showComparablePrices
    showDiscussion.value = data.showDiscussion
    showCounsellingBanner.value = data.showCounsellingBanner
    mostSoldProducts.value = data.mostSoldProducts

    if (process.client) {
        await nextTick()
        const scrollElementId = route.hash.replace(/^#/, '')
        const scrollElement = document.getElementById(scrollElementId)
        if (scrollElement) {
            const scrollTo = scrollElement.getBoundingClientRect().top + window.scrollY
            window.scroll({ top: scrollTo, behavior: 'smooth' })
            document.body.classList.add('header-sticky')
        }
    }
}

const { productListData, filtersData, richContentData } = await useProductListPageAsyncData({
    needsFiltersAndRichContent: true,
    inputPageFrom: null,
    inputPageTo: null,
    id,
    type: type.value,
})

if (!productListData.value) {
    throw createError({ statusCode: 404, statusMessage: 'Product list not found' })
}

if (productListData.value.response && productListData.value.response.redirectUrl) {
    const external = productListData.value.response.redirectUrl.startsWith('http')

    await safeNavigateTo(productListData.value.response.redirectUrl, { external })
}

const encodeFilters = (filters: Filter[]) => {
    return filters.map((filter: Filter) => {
        return {
            ...filter,
            urlMask: encodeSeoUrl(filter.urlMask || ''),
            options: (filter.options || []).map((option) => {
                return {
                    ...option,
                    url: encodeSeoUrl(option.url),
                }
            }),
            items: (filter.items || []).map((item) => {
                return {
                    ...item,
                    url: encodeSeoUrl(item.url),
                }
            }),
        }
    })
}

const finalFilters = encodeFilters(filtersData.value.response.filters)

setData(
    productListData.value.response,
    finalFilters,
    richContentData.value.response.richContentWidgets,
    richContentData.value.response.bottomRichContentWidgets
)

watch(
    () => route.query,
    async () => {
        const {
            productListData: newProductListData,
            filtersData: newFiltersData,
            richContentData: newRichContentData,
        } = await useProductListPageAsyncData({
            needsFiltersAndRichContent: true,
            inputPageFrom: null,
            inputPageTo: null,
            id,
            type: type.value,
        })

        pageFrom = parseInt((route.query.page || '1') as string)
        pageTo = pageFrom

        setData(
            newProductListData.value.response,
            encodeFilters(newFiltersData.value?.response?.filters || []),
            newRichContentData.value.response.richContentWidgets,
            newRichContentData.value.response.bottomRichContentWidgets
        )

        registerNextPageButtonObserver()
    }
)

useRouter().beforeEach((_to, from, next) => {
    referer.value = from as unknown as string
    next()
})

const pushViewItemListEvents = () => {
    const layoutStore = useLayoutStore()
    layoutStore.setStructuredData(structuredData.value)

    const level = categoryLevel.value

    const page = {
        type: 'category',
        title: (metaObject.title as string).trim(),
        referer: referer.value,
    } as GtmPageData

    if (componentName === 'catalog.list') {
        page.category_id = parseInt(params.id)
    }

    if (componentName === 'catalog.search') {
        page.type = 'search'
        page.search_term = title.value.trim()
    }

    if (level) {
        page.level = `L${level}`
    }

    if (componentName === 'catalog.product_line') {
        page.type = 'product_line'
    }

    if (componentName === 'catalog.manufacturer') {
        page.type = 'producer'
    }

    if (componentName === 'catalog.brand') {
        page.type = 'brand'
    }

    DataLayer.pushPageViewToDataLayer(page)

    if (page.type === 'search') {
        const luigisBoxFilters: LuigisBoxFilters = {
            'Sort by': currentSortName.value,
        }
        selectedFilters.value.forEach((filter) => {
            const key = filter.type || filter.value
            if (Array.isArray(luigisBoxFilters[key])) {
                ;(luigisBoxFilters[key] as string[]).push(filter.value)
            } else if (typeof luigisBoxFilters[key] === 'string') {
                luigisBoxFilters[key] = [filter.value, luigisBoxFilters[key]]
            } else {
                luigisBoxFilters[key] = filter.value
            }
        })
        if (page.search_term) {
            LuigisBoxEventApi.sendSearchPageView(page.search_term, transformProductsToLuigisBoxItems(products.value), luigisBoxFilters)
        }
        DataLayer.push({
            event: 'search',
            search: {
                query: page.search_term,
                type: 'fulltext',
                results: {
                    products: totalCount.value,
                },
            },
            _clear: true,
        })
    } else {
        LuigisBoxEventApi.sendPageView()
        const ecommerceEvent = {
            type: GtmEcommerceEventTypeEnum.ViewProductList,
            listName: DataLayer.getListName(title.value, page.type),
            products: products.value.map((product) => {
                return transformProductToGtmProduct(product)
            }),
            isListPositionEnabled: true,
            page: Number(route.query.page) || null,
        } as GtmEcommerceEvent

        DataLayer.pushEcommerceEventToDataLayer(ecommerceEvent)
    }
}

const currentTab = ref(TAB_PRODUCTS)
if (showDiscussion.value) {
    currentTab.value = TAB_DISCUSSIONS
}
if (showCommentAggregate.value) {
    currentTab.value = TAB_REVIEWS
}

const currentSortName = computed(() => {
    for (const { id, name } of sorts.value) {
        if (id === sortMethod) {
            return name
        }
    }

    return ''
})

const isDiscussionsEnabled = computed(() => {
    return config.public.discussionsEnabled
})

const showMoreCount = computed(() => {
    if (totalCount.value < 36) {
        return Math.min(36, Math.max(totalCount.value - products.value.length, 0) * pageFrom)
    }
    return Math.min(36, Math.max(totalCount.value - 36, 0) * pageFrom)
})

const chatBotShow = computed(() => {
    let id = null
    let dictKey = ''
    if (['catalog.product_line', 'catalog.list', 'catalog.brand'].includes(componentName)) {
        id = params.id
        switch (componentName) {
            case 'catalog.product_line':
                dictKey = 'productLine'
                break
            case 'catalog.brand':
                dictKey = 'brand'
                break
            default:
                dictKey = 'category'
        }
    }

    if (
        config.public.isChatBotEnabled &&
        id !== null &&
        (i18n.tm(`chatBot.${dictKey}`) as number[])
            .map(function (e) {
                return e.toString()
            })
            .includes(id)
    ) {
        metaObject.script?.push({
            type: 'text/javascript',
            src: 'https://static.bots.sefbot.cz/website/js/widget2.db8fbf7f.min.js',
            // @ts-ignore
            crossorigin: 'crossorigin',
            async: true,
            defer: true,
            'data-no-minify': '1',
        })

        return true
    }

    return false
})

const showNextPageLoading = ref(false)
const showNextPage = () => {
    // showNextPageLoading.value = true

    setTimeout(async () => {
        pageFrom += 1
        pageTo += 1

        const { data: productListData } = await useProductListAsyncData(
            {
                needsFiltersAndRichContent: false,
                inputPageFrom: pageFrom,
                inputPageTo: pageTo,
                id,
                type: type.value,
            },
            false
        )
        const { products: newProducts, paginator: newPaginator } = productListData.value.response

        products.value.push(...newProducts.products)
        paginator.value = newPaginator
        showNextPageLoading.value = false

        registerNextPageButtonObserver()
    }, 0)
}

const showNextPageButton = ref<HTMLInputElement | null>(null)

onMounted(() => {
    if (typeof window !== 'undefined' && window.IntersectionObserver) {
        registerNextPageButtonObserver()
    }
})

const registerNextPageButtonObserver = () => {
    const element = showNextPageButton.value
    if (!element) {
        return
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(({ isIntersecting }) => {
                if (isIntersecting) {
                    preloadNextPage()
                    observer.disconnect()
                }
            })
        },
        { rootMargin: '0px' }
    )

    observer.observe(element)
}

const preloadNextPage = () => {
    useProductListAsyncData(
        {
            needsFiltersAndRichContent: false,
            inputPageFrom: pageFrom + 1,
            inputPageTo: pageTo + 1,
            id,
            type: type.value,
        },
        false
    )
}

const showSidebar = (sidebarMode: string) => {
    setTimeout(() => {
        const layoutStore = useLayoutStore()
        layoutStore.setShowSidebarMode(sidebarMode)
    }, 0)
}

const productList = ref<HTMLElement>()

const showDiscussions = () => {
    currentTab.value = TAB_DISCUSSIONS
    let topPosition = productList.value?.offsetTop || 500
    const discussionsEl = document.getElementsByClassName('services-list')
    if (discussionsEl.length > 0) {
        topPosition = (discussionsEl[0] as HTMLElement).offsetTop - 100
    }
    // Hack for Safari and mobile browsers
    setTimeout(() => {
        window.scroll({ top: topPosition, behavior: 'smooth' })
    }, 100)
    // window.scroll({ top: topPosition, behavior: 'smooth' })
}

const showReviews = () => {
    currentTab.value = TAB_REVIEWS
    let topPosition = productList.value?.offsetTop || 500
    const discussionsEl = document.getElementsByClassName('services-list')
    if (discussionsEl.length > 0) {
        topPosition = (discussionsEl[0] as HTMLElement).offsetTop - 200
    }
    // Hack for Safari and mobile browsers
    setTimeout(() => {
        window.scroll({ top: topPosition, behavior: 'smooth' })
    }, 100)
}

const backToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

let customCanonical = null as string | null
if (type.value === 'manufacturer') {
    customCanonical = `${config.public.apiUrl}${baseUrl.value}`
}

const metaObject = useNuxtApp().$constructHead({
    headInfo: route.meta.headInfo as PilulkaHeadInfo,
    customTitle: metaTitle.value ?? title.value,
    customMetaDescription: metaDescription.value,
    customCanonical,
})

metaObject.bodyAttrs = {
    'data-no-cache': true,
}

if (richContentWidgets.value.length > 0 || bottomRichContentWidgets.value.length > 0) {
    metaObject.link?.push({
        rel: 'stylesheet',
        href: '/dist/rich-content-css.css?v=1',
    })
    metaObject.script?.push({
        src: '/rich-content/js/app.js',
        // @ts-ignore
        body: true,
        async: true,
    })
}

if (banners.value.length) {
    metaObject.link?.push({
        rel: 'preload',
        href: banners.value[0].cdnImage,
        as: 'image',
    })
}

const { isDesktop } = useDevice()
if (products.value.length > 0 && isDesktop) {
    const count = Math.min(products.value.length, 3)
    for (let i = 0; i < count; i++) {
        metaObject.link?.push({
            rel: 'preload',
            href: products?.value[i]?.imageBySize?.imageCdn160,
            as: 'image',
        })
    }
}

useHead(metaObject)

const i18n = useI18n()
useJsonld(() => {
    const commonStructuredData = useCommonStructuredData({
        config,
        i18nTranslate: i18n.t,
        breadcrumbsItems: breadcrumbs.value,
        addSearchAction: false,
    })

    return [...commonStructuredData]
})

const updateReviewsCount = (count: number) => {
    reviewsCount.value = count
}

const backToProducts = () => {
    currentTab.value = TAB_PRODUCTS
}

const leftSideBanner = ref<Banner | null>(null)
const rightSideBanner = ref<Banner | null>(null)
const layoutStore = useLayoutStore()
leftSideBanner.value = layoutStore.leftSideBanner
rightSideBanner.value = layoutStore.rightSideBanner

const perexTitle = computed(() => {
    const perexTitle = componentName === 'catalog.search' ? `${trans('search.searchResultsForTerm')}: ${title.value}` : title.value
    if (currentTab.value === TAB_REVIEWS) {
        return `${perexTitle} - ${trans('reviews.reviewsAndExperience')}`
    }

    if (currentTab.value === TAB_DISCUSSIONS && !perexTitle.includes(trans('discussions.titleSuffix'))) {
        return `${perexTitle} - ${trans('discussions.titleSuffix')}`
    }
    return perexTitle
})

const hasNavigationRichContentWidget = computed(() => {
    for (let i = 0; i < richContentWidgets.value.length; i++) {
        const widget = richContentWidgets.value[i]
        if (widget.type === 13) {
            return true
        }
    }

    return false
})

provide('showComparablePrices', showComparablePrices)
</script>

<style lang="scss" scoped>
.sort {
    position: relative;
}

.services-list__bottom {
    @media (max-width: $screen-xl) {
        flex-direction: column;
    }

    .pagination {
        margin-bottom: 0;
    }
}

#subCategoriesBTest {
    display: none;
}

.wrap-backtop {
    text-align: left;

    @include screen-xl {
        flex: 0 0 280px;
    }
}

.backtop {
    display: inline-block;
    width: auto;
    height: auto;
    opacity: 1;
    position: static;
    padding-left: 50px;
    transition: 150ms ease-in-out;
    background: url(/nuxt-assets/images/icons/arrow-light-top.svg) no-repeat 0 -3px;
    background-size: 30px 30px;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
        transition: 150ms ease-in-out;
        background: url(/nuxt-assets/images/icons/arrow-light-top.svg) no-repeat 0 -5px;
        background-size: 30px 30px;
    }
}

.list-tabs {
    .nav-pills .nav-link {
        border-radius: 10px;
        margin-right: 0.5em;
        background-color: $color-white;
        color: $color-dark;
        margin-bottom: 0;
        font-size: 14px;
        white-space: nowrap;
        padding: 0.65rem 1rem;

        &.active {
            color: $color-dark;
            background-color: $color-grey;
        }
    }

    &--classic .nav-pills .nav-link {
        background-color: transparent;
        font-weight: 500;

        &.active {
            color: $color-dark;
            background-color: $color-grey;
        }
    }
}

.pagination__load-more.btn-link {
    white-space: nowrap;
    text-decoration: none;
    font-weight: 700;

    &:hover {
        text-decoration: underline;
    }
}

.lists-filter {
    width: 100%;
    @include screen-md {
        width: auto;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 1em;
        align-items: center;
    }
}

.page__sidebar {
    position: relative;
    z-index: 311;

    @include screen-md {
        z-index: 9;
    }

    &--overlay {
        opacity: 0.33;

        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
            width: 100%;
            height: 100%;
        }
    }
}

.product-listScroll {
    position: relative;
    top: -160px;
}

.btn-discussion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
}
</style>
